import ArtTrackIcon from '@mui/icons-material/ArtTrack';
import DeleteIcon from '@mui/icons-material/Delete';
import ImageIcon from '@mui/icons-material/Image';
import { Button, Grid, IconButton, MenuItem, TextField, Tooltip } from "@mui/material";
import Box from "@mui/material/Box";
import Divider from '@mui/material/Divider';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import React, { useRef, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { useDispatch, useSelector } from "react-redux";
import { addActualite } from "../../store/siteWebSlice";
import { SITEWEB_SERVER_BASE_URL, apiClient } from "../../util/apiClient";
import { convertToBase64, errorNotify, successNotify } from "../../util/functions";
import PostDialog from "../components/PostDialog";
import { IPayloadActualite } from "./interface";
import { IReduxState } from '../../store';
import AddIcon from '@mui/icons-material/Add';

interface IAddProps {
  actualiteState: IPayloadActualite;
  setActualiteState: (x: IPayloadActualite) => void;
  setSelectedPhoto: (x: any) => void;
  photosGalerieBase64: any;
  setPhotosGalerieBase64: (x: any) => void;
  image: string;
  setImage: (x: string) => void;
}


const Add = (props: IAddProps) => {

  //props
  const {
    actualiteState,
    setActualiteState,
    setSelectedPhoto,
    photosGalerieBase64,
    setPhotosGalerieBase64,
    image,
    setImage
  } = props
  //redux
  const { categories } = useSelector((state: IReduxState) => state.siteWeb);

  //hooks
  const selectPhoto: any = useRef(null);
  const selectGaleriePhoto: any = useRef(null);
  const [loadingSelectGaleriePhoto, setLoadingSelectGaleriePhoto] = React.useState<boolean>(false);


  //fonctions
  const handleInputChange = (e: any) => {
    const { value, name } = e.target
    setActualiteState({ ...actualiteState, [name]: value })
  }


  /**
   * cette fonction permet de charger les images de la galérie
   *  puis transforme le fichier en base 64
   * @param event 
   */
  const handleAddGaleriePhotosBase64 = (event: any) => {
    setLoadingSelectGaleriePhoto(true)
    const fileList = event.target.files;
    const fileObjects: any = Array.from(fileList).map((file: any) => {
      const reader = new FileReader();
      reader.readAsDataURL(file); // Lit le fichier en tant que DataURL
      // Crée une promesse pour attendre la fin de la lecture du fichier
      return new Promise((resolve) => {
        reader.onloadend = () => {
          resolve({
            name: file.name,
            size: file.size,
            type: file.type,
            lastModified: file.lastModified,
            url: reader.result, // Récupère le résultat en tant que DataURL
            id: file.lastModified
          });
        };
      });
    });
    // Attend que toutes les promesses soient résolues
    Promise.all(fileObjects).then((results) => {
      setPhotosGalerieBase64([...photosGalerieBase64, ...results]);
      setLoadingSelectGaleriePhoto(false)
    });
  };


  /**
   * Permet de supprimer une image du tableau local.
   * @param currentIndex 
   */
  const handlePhotoDelete = (currentIndex: number) => {
    let newData = [...photosGalerieBase64]
    const res = newData.filter((item, index) => index !== currentIndex)
    setPhotosGalerieBase64(res)
  };


  /**
 *  cette fonction permet de repositionner les images
 * @param result (draggableId, source, destination)
 * (draggableId:l'identifiant de l'image à deplacer)
 * (source:la position de depart de l'image à deplacer)
 * (destination:la position d'arriver de l'image à deplacer)
 * @returns
 *
 */
  const onDragEnd = (result: any) => {
    const { draggableId, source, destination } = result;
    const parseIntdraggableId = parseInt(draggableId);
    //Ne rien executer si on deplace un item hors de la carde
    if (!destination) {
      return;
    }
    //Ne rien executer si l'on bouge un item et qu'on le remet à sa place
    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    ) {
      return;
    }
    //obtenir l'objet à repositionnner
    const sectionARepositionner: any = photosGalerieBase64?.find(
      (section: any) => section.id === parseIntdraggableId
    );
    //remplacer les places dans le tableau
    let newPhotoGalerie = [...photosGalerieBase64];
    newPhotoGalerie.splice(source.index, 1);
    newPhotoGalerie.splice(destination.index, 0, sectionARepositionner);
    //mettre à jour les index de chaque section
    const newPhotoGalerieOrdered = newPhotoGalerie.map((section: any, i: number) => {
      const newSection = { ...section, id: section.id + 1 };
      return newSection;
    });
    //mise à jour du state
    setPhotosGalerieBase64(newPhotoGalerieOrdered);
    return;
  };



  return (
    <Box sx={{ flexGrow: 1, width: "100%" }}>
      <Grid
        container
        spacing={2}
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
      >
        <Grid item md={3} xs={12} sm={3}>
          <TextField
            fullWidth
            size="small"
            name="titre"
            label="Titre"
            value={actualiteState.titre}
            onChange={handleInputChange}
          />
        </Grid>

        <Grid item md={3} xs={12} sm={3}>
          <TextField
            fullWidth
            size="small"
            name="sousTitre"
            label="Sous titre"
            value={actualiteState.sousTitre}
            onChange={handleInputChange}
          />
        </Grid>

        <Grid item md={3} xs={12} sm={3}>
          <TextField
            fullWidth
            style={{ marginTop: 25 }}
            size="small"
            name="dateActualite"
            type="date"
            helperText="Date de l'évènement"
            value={actualiteState.dateActualite}
            onChange={handleInputChange}
          />
        </Grid>

        <Grid item md={4} xs={12} sm={4}>
          <Grid
            container
            spacing={2}
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <Grid item md={12} xs={12} sm={12}>
              <img
                src={image}
                style={{ width: "25vw", height: "30vh", border: "10px groove black" }}
              />
            </Grid>

            <Grid item md={12} xs={12} sm={12}>
              <Tooltip title="Charger l'image descriptive de l'actualité">
                <Button
                  variant="outlined"
                  color="primary"
                  component="label"
                  startIcon={<ImageIcon />}
                  style={{ marginTop: 10, width: "100%" }}
                  onClick={() => {
                    selectPhoto?.current?.click();
                  }}
                >
                  Charger l'image
                </Button>
              </Tooltip>
              <input
                hidden
                multiple
                type="file"
                name="pieceJointe"
                ref={selectPhoto}
                onChange={(e: any) => {
                  const files = e.target.files[0];
                  if (files) {
                    const img = URL.createObjectURL(files);
                    setImage(img);
                    setSelectedPhoto(e.target.files[0]);
                  }
                }}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item md={8} xs={12} sm={8}>
          <TextField
            fullWidth
            multiline
            minRows={10}
            name="texteComplet"
            label="Saisir le texte complet"
            value={actualiteState.texteComplet}
            onChange={handleInputChange}
          />
        </Grid>

        <Grid item md={12} xs={12} sm={12}>
          <Divider />
        </Grid>

        <Grid item md={12} xs={12} sm={12}>
          <Grid
            container
            spacing={2}
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >

            <Grid item md={4} xs={12} sm={4}>
              <Tooltip title="Charger les images de la galérie">
                <Button
                  variant="outlined"
                  color="primary"
                  component="label"
                  startIcon={<ArtTrackIcon />}
                  style={{ marginTop: 10 }}
                  onClick={() => {
                    selectGaleriePhoto?.current?.click();
                  }}
                >
                  Charger les images de la galérie liée à cet article
                </Button>
              </Tooltip>
              <input
                hidden
                multiple
                type="file"
                name="galeriePhoto"
                ref={selectGaleriePhoto}
                onChange={handleAddGaleriePhotosBase64}
              />
            </Grid>

            <Grid item md={8} xs={12} sm={8}>
              <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="droppable" direction="vertical">
                  {(provider: any) => (
                    <div
                      style={{
                        background: "aliceblue",
                        padding: 10,
                        height: "50vh",
                        overflow: "auto",
                      }}
                      ref={provider.innerRef}
                      {...provider.droppableProps}
                    >
                      <Box sx={{ flexGrow: 1, width: "100%" }}>
                        <List dense={true}>
                          <Grid
                            container
                            spacing={2}
                            direction="row"
                            justifyContent="flex-start"
                          >
                            {photosGalerieBase64.length > 0 &&
                              photosGalerieBase64.map((item: any, i: number) => {
                                const newIndex = item.id.toString();
                                return (
                                  <div key={item.id}>
                                    <Draggable draggableId={newIndex} index={i}>
                                      {(provider: any, snapshot: any) => (
                                        <div
                                          ref={provider.innerRef}
                                          {...provider.draggableProps}
                                          {...provider.dragHandleProps}
                                        >
                                          <ListItem
                                            secondaryAction={
                                              <IconButton
                                                onClick={() =>
                                                  handlePhotoDelete(i)
                                                }
                                              >
                                                <DeleteIcon fontSize="small" />
                                              </IconButton>
                                            }
                                          >
                                            <img src={item.url} alt={item.name} style={{ width: "20%", height: "20%" }} />
                                          </ListItem>
                                          <Divider />
                                          {provider.placeholder}
                                        </div>
                                      )}
                                    </Draggable>
                                  </div>
                                );
                              })}
                            {loadingSelectGaleriePhoto && "Veuillez patienter svp..."}
                          </Grid>
                        </List>
                      </Box>
                      {provider.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};







export const initialState = {
  titre: "",
  sousTitre: "",
  texteComplet: "",
  dateActualite: "",
  actualiteImageEnBase64: ""
}


const DialogAdd = () => {

  //redux
  const dispatch = useDispatch();

  //hooks
  const [open, setOpen] = useState<boolean>(false)
  const [addLoading, setAddLoading] = useState<boolean>(false)
  const [actualiteState, setActualiteState] = useState<IPayloadActualite>(initialState)
  const [photosGalerieBase64, setPhotosGalerieBase64] = useState<any>([]);
  const [selectedPhoto, setSelectedPhoto] = useState<any>({})
  const [image, setImage] = useState<string>("");

  //Ouvrir la boite de dialog 
  const onClose = () => {
    setOpen(false)
  }

  //Fermer la boite de dialog
  const handleOpenDialog = () => {
    setOpen(true)
  }


  /**
   * Permet d'enregistrer une actualité dans la base de donnée
   * @param e 
   */
  const handleActualiteSave = async (e: any) => {
    try {
      e.preventDefault()
      setAddLoading(true)

      //Obtenir un tableau d'élèment des images de la galérie en base 64
      let imagesDuDossierEnBase64: string[] = []
      photosGalerieBase64.map(async (item: any) => {
        imagesDuDossierEnBase64.push(item.url)
      })

      //Obtenir l'image qui decrit l'actualité en base 64
      const actualiteImageEnBase64: any = selectedPhoto ? await convertToBase64(selectedPhoto) : "";

      //Constituer le payload final
      const apiPayload: IPayloadActualite = {
        ...actualiteState,
        actualiteImageEnBase64: actualiteImageEnBase64,
        imagesDuDossierEnBase64: imagesDuDossierEnBase64
      }

      // Envoi de la requête 
      const res: any = await apiClient.post(
        SITEWEB_SERVER_BASE_URL,
        "/ajouteractualiteetdossierimage",
        apiPayload
      );

      if (res.status === 1) {
        dispatch(addActualite(res.data.actualite))
        successNotify("Action effectuée avec succès");
        setAddLoading(false)
        setActualiteState(initialState)
        setImage("")
        setPhotosGalerieBase64([])
      } else {
        errorNotify("Erreur");
        setAddLoading(false)
      }
    } catch (error) {
      setAddLoading(false)
      console.log("🚀 ~ file: Add.tsx:305 ~ handleActualiteSave ~ error:", error)
    }
  }


  return (
    <PostDialog
      onClose={onClose}
      open={open}
      dialogContent={
        <Add
          actualiteState={actualiteState}
          setActualiteState={setActualiteState}
          setSelectedPhoto={setSelectedPhoto}
          photosGalerieBase64={photosGalerieBase64}
          setPhotosGalerieBase64={setPhotosGalerieBase64}
          image={image}
          setImage={setImage}
        />}
      actionFunc={handleActualiteSave}
      title="Actualité"
      addLoading={addLoading}
      handleOpenDialog={handleOpenDialog}
    />

  );
};
export default DialogAdd;



